import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import RustChat from '../components/RustChat';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { useIsMobile } from '../hooks/use-mobile';

const useQuery = () => new URLSearchParams(useLocation().search);

const SearchPage = () => {
  const query = useQuery();
  const location = useLocation();
  const searchTerm = query.get('q')?.toLowerCase().trim() || '';
  const isMobile = useIsMobile();
  const [previewEmbedId, setPreviewEmbedId] = useState<string | null>(null);
  const [previewType, setPreviewType] = useState<'rustico' | 'youtube' | null>(null);
  const [messages, setMessages] = useState<{ question: string; answer: string }[]>([]);
  const [showChat, setShowChat] = useState(true);
  const chatEndRef = useRef<HTMLDivElement>(null);
  const [youtubeVideos, setYoutubeVideos] = useState<any[]>([]);

  const shouldShowUI = !['/landing', '/login', '/signup'].includes(location.pathname);

  const allVideos = [
  {
    "id": "exclusivo-1",
    "title": "Exclusivo: A Mesma Mentira",
    "description": "Aluguel individual exclusivo.",
    "thumbnail": "/img/A_Mesma_Mentira.png",
    "embedId": "3644a684f98ea8fe223c713b77189a77",
    "category": "exclusivos"
  },
  {
    "id": "exclusivo-2",
    "title": "Exclusivo: Frente Fria",
    "description": "Show disponível apenas por aluguel.",
    "thumbnail": "/img/Frente_Fria.png",
    "embedId": "757b505cfd34c64c85ca5b5690ee5293",
    "category": "exclusivos"
  },
  {
    "id": "show-1",
    "title": "Zezé Di Camargo - Frente Fria",
    "description": "Show exclusivo da turnê Frente Fria.",
    "thumbnail": "/img/Frente_Fria.png",
    "embedId": "0aa1883c6411f7873cb83dacb17b0afc",
    "category": "shows"
  },
  {
    "id": "show-2",
    "title": "Zezé Di Camargo | Rústico - A Origem",
    "description": "Documentário musical sobre as raízes de Zezé.",
    "thumbnail": "/img/A_Origem.png",
    "embedId": "58a2fc6ed39fd083f55d4182bf88826d",
    "category": "shows"
  },
  {
    "id": "show-3",
    "title": "Pra não pensar em você",
    "description": "Clássico de Zezé & Luciano.",
    "thumbnail": "/img/zeze&luciano.jpg",
    "embedId": "1c9ac0159c94d8d0cbedc973445af2da",
    "category": "shows"
  },
  {
    "id": "show-4",
    "title": "Ed. & Hud.- Jaguariuna",
    "description": "Show ao vivo emocionante.",
    "thumbnail": "/img/edson_hudson.png",
    "embedId": "2a79ea27c279e471f4d180b08d62b00a",
    "category": "shows"
  },
  {
    "id": "show-5",
    "title": "Victor e Leo | Irmãos",
    "description": "Show da dupla Victor e Leo.",
    "thumbnail": "/img/Victor_e_Leo.jpg",
    "embedId": "0777d5c17d4066b82ab86dff8a46af6f",
    "category": "shows"
  },
  {
    "id": "show-6",
    "title": "Chitãozinho e Xororó | Turnê 50 anos",
    "description": "Comemoração dos 50 anos da dupla.",
    "thumbnail": "/img/chitaozinho-e-xororo.jpg",
    "embedId": "82aa4b0af34c2313a562076992e50aa3",
    "category": "shows"
  },
  {
    "id": "show-7",
    "title": "Fern. & Soroc. | Jaguariuna",
    "description": "Show com hits da dupla.",
    "thumbnail": "/img/fernando_sorocaba.jpeg",
    "embedId": "b73ce398c39f506af761d2277d853a92",
    "category": "shows"
  },
  {
    "id": "filme-1",
    "title": "2 Filhos de Francisco",
    "description": "A trajetória emocionante da dupla Zezé & Luciano.",
    "thumbnail": "/img/2_Filhos_de_Francisco.jpg",
    "embedId": "1d7f7abc18fcb43975065399b0d1e48e",
    "category": "filmes"
  },
  {
    "id": "filme-2",
    "title": "O Menino da Porteira",
    "description": "Drama clássico do sertanejo.",
    "thumbnail": "/img/menino_da_porteira.jpg",
    "embedId": "140f6969d5213fd0ece03148e62e461e",
    "category": "filmes"
  },
  {
    "id": "filme-3",
    "title": "É o Amor",
    "description": "Romance musical baseado em grandes sucessos.",
    "thumbnail": "/img/e_o_amor.jpg",
    "embedId": "3636638817772e42b59d74cff571fbb3",
    "category": "filmes"
  },
  {
    "id": "filme-4",
    "title": "Só se for por Amor",
    "description": "Uma história envolvente com trilha sertaneja.",
    "thumbnail": "/img/So_se_for_por_Amor.jpg",
    "embedId": "149e9677a5989fd342ae44213df68868",
    "category": "filmes"
  },
  {
    "id": "ult-1",
    "title": "Zezé Di Camargo|Rustico-Cuiabá",
    "description": "Show especial direto de Cuiabá.",
    "thumbnail": "/img/show_em_cuiaba.png",
    "embedId": "a597e50502f5ff68e3e25b9114205d4a",
    "category": "ultimosVistos"
  },
  {
    "id": "ult-2",
    "title": "Navio do Zezé",
    "description": "Cruzeiro especial com Zezé Di Camargo.",
    "thumbnail": "/img/navio-do-zezé.png",
    "embedId": "6c4b761a28b734fe93831e3fb400ce87",
    "category": "ultimosVistos"
  },
  {
    "id": "ult-3",
    "title": "Victor e Leo | Irmãos",
    "description": "Show da dupla Victor e Leo.",
    "thumbnail": "/img/Victor_e_Leo.jpg",
    "embedId": "0777d5c17d4066b82ab86dff8a46af6f",
    "category": "ultimosVistos"
  },
  {
    "id": "ult-4",
    "title": "Oa Amigos",
    "description": "Especial com os amigos da música sertaneja.",
    "thumbnail": "/img/os_amigos.png",
    "embedId": "006f52e9102a8d3be2fe5614f42ba989",
    "category": "ultimosVistos"
  },
  {
    "id": "ult-5",
    "title": "Fazenda é o Amor",
    "description": "Romance rural musical.",
    "thumbnail": "/img/fazenda-é-o-amor.jpg",
    "embedId": "6c4b761a28b734fe93831e3fb400ce87",
    "category": "ultimosVistos"
  },
  {
    "id": "ult-6",
    "title": "Navio do Zezé (Replay)",
    "description": "Reprise do show no navio do Zezé.",
    "thumbnail": "/img/navio-do-zezé.png",
    "embedId": "9766527f2b5d3e95d4a733fcfb77bd7e",
    "category": "ultimosVistos"
  }
]; // mantido como está para brevidade

  const filteredRustico = allVideos.filter(video =>
    video.thumbnail &&
    searchTerm.split(' ').some(word =>
      video.title.toLowerCase().includes(word) ||
      video.description.toLowerCase().includes(word)
    )
  );

  const filteredYoutube = youtubeVideos.filter(video =>
    video.thumbnail &&
    searchTerm.split(' ').some(word =>
      video.title.toLowerCase().includes(word) ||
      video.description.toLowerCase().includes(word)
    )
  );

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  useEffect(() => {
    if (!searchTerm) return;
    fetch(`https://www.googleapis.com/youtube/v3/search?part=snippet&type=video&videoEmbeddable=true&channelId=UCWJfEjiztBbf__7XL14iUyg&maxResults=20&q=${encodeURIComponent(searchTerm)}&key=AIzaSyC-oN-MU9L7aKlsEDmpRPW04jYkjM3CFM8`)
      .then(res => res.json())
      .then(data => {
        const videos = (data.items || []).map(item => ({
          id: item.id.videoId,
          title: item.snippet.title,
          description: item.snippet.description,
          thumbnail: item.snippet.thumbnails?.high?.url || item.snippet.thumbnails?.medium?.url || item.snippet.thumbnails?.default?.url || '',
          embedId: item.id.videoId
        })).filter(v => v.embedId && v.thumbnail);
        setYoutubeVideos(videos);
      }).catch(err => console.error('Erro ao buscar vídeos do YouTube:', err));
  }, [searchTerm]);

  return (
    <div className="bg-[#141414] text-white min-h-screen">
      {shouldShowUI && <Header />}
      {shouldShowUI && <RustChat />}
      <main className="pt-[120px] px-4">
        <div className="container mx-auto max-w-6xl">
          <h1 className="text-3xl font-bold mb-4">Resultados para: "{searchTerm}"</h1>

          {filteredRustico.length > 0 && (
            <>
              <h2 className="text-xl font-semibold mb-2">Rustico Play</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-6">
                {filteredRustico.map(video => (
                  <div key={video.id} className="bg-black/40 rounded-lg overflow-hidden shadow">
                    <img src={video.thumbnail} alt={video.title} className="w-full h-48 object-cover" />
                    <div className="p-4">
                      <h2 className="text-lg font-semibold mb-1 line-clamp-2">{video.title}</h2>
                      <p className="text-sm text-gray-400 line-clamp-3 mb-2">{video.description}</p>
                      <Button
                        onClick={() => {
                          setPreviewEmbedId(video.embedId);
                          setPreviewType('rustico');
                        }}
                        className="w-full py-2 px-4 rounded-full text-sm font-semibold bg-rustico-orange text-white hover:bg-orange-700 transition"
                      >
                        Assistir no RusticoPlay
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {filteredYoutube.length > 0 && (
            <>
              <h2 className="text-xl font-semibold mb-2">YouTube - Zezé Di Camargo</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {filteredYoutube.map(video => (
                  <div key={video.id} className="bg-black/40 rounded-lg overflow-hidden shadow">
                    <img src={video.thumbnail} alt={video.title} className="w-full h-48 object-cover" />
                    <div className="p-4">
                      <h2 className="text-lg font-semibold mb-1 line-clamp-2">{video.title}</h2>
                      <p className="text-sm text-gray-400 line-clamp-3 mb-2">{video.description}</p>
                      <Button
                        onClick={() => {
                          setPreviewEmbedId(video.embedId);
                          setPreviewType('youtube');
                        }}
                        className="w-full py-2 px-4 rounded-full text-sm font-semibold bg-red-600 text-white hover:bg-red-700 transition"
                      >
                        Assistir no RusticoPlay
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </main>
      {shouldShowUI && <Footer />}

      {previewEmbedId && (
        <Dialog open={true} onOpenChange={() => setPreviewEmbedId(null)}>
          <DialogContent className="w-full h-[82vh] max-w-5xl bg-black">
            <div className="relative w-full h-full">
              <iframe
                src={
                  previewType === 'youtube'
                    ? `https://www.youtube.com/embed/${previewEmbedId}`
                    : `https://audtex-poc.xtream.tech/embed/${previewEmbedId}`
                }
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                className="absolute top-0 left-0 w-full h-full"
                title="Player do vídeo"
              />
            </div>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default SearchPage;
